import { Space } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import TableWithSorter from '../Common/TableWithSorter';

const UnitOfferTable = (props) => {
  const dateFormat = 'dddd, Do MMMM YYYY h:mm:ssA Z';
  const data = props.data.map((unitOffer) => {
    return {
      ...unitOffer,
      startDate: moment.utc(unitOffer.startDate).local().format(dateFormat),
      endDate: moment.utc(unitOffer.endDate).local().format(dateFormat),
    };
  });
  const columns = [
    {
      title: 'ID',
      dataIndex: '_id',
      key: '_id',
    },
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      render: (text, record) => (
        <Space size="middle">
          <Link to={'/unit-offer/' + record.unitOfferId}>{text}</Link>
        </Space>
      ),
    },
    {
      title: 'Description',
      dataIndex: 'unitDescription',
      key: 'description',
    },
    {
      title: 'Course Offer',
      dataIndex: ['courseOffer', 'code'],
      key: 'courseOffer',
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      key: 'startDate',
      sorter: (a, b) => {
        return (
          moment(a.startDate, dateFormat) - moment(b.startDate, dateFormat)
        );
      },
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      key: 'endDate',
      sorter: (a, b) =>
        moment(a.startDate, dateFormat) - moment(b.startDate, dateFormat),
      sortDirections: ['descend', 'ascend'],
    },
  ];

  return (
    <TableWithSorter
      tableLayout="auto"
      scroll={{ x: 1000 }}
      expandable={{ defaultExpandAllRows: true }}
      dataSource={data}
      columns={columns}
      pagination={{
        defaultPageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30'],
      }}
    />
  );
};

export default UnitOfferTable;
